import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import '../../../components/core/BannerWelcome/BannerWelcome.css';




interface BannerWelcomeProps {
    username: string;
  }
  
  const BannerWelcome: FC<BannerWelcomeProps> = ({ username }) => (
    <div className="BannerWelcome-container">
        <div className="Banner-Container">
      <section className="pds-welcomeBanner pds-typography-center pds-welcomeBanner-background-gradient pds-color-font-neutral-white">
        <h2 className="pds-welcomeBanner-header">Hola!</h2>
        <p className="pds-welcomeBanner-message">
          {`Bienvenido al Repositorio Documental, ${username}!`}
        </p>
      </section>
      </div>
    </div>
  );
  
  export default BannerWelcome;